<template>
  <div>
    <br />
    <div class="row justify-content-end">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-plus-circle"></i>
          Actualiser
        </button>
      </div>
    </div>
    <br />

    <h5 class="mb-3">Informations du Vendeur</h5>
    <div class="row">
      <div class="col-xl-3 col-12 my-3">
        <label for=""> ID </label>
        <div>
          {{ seller.id || "—" }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Référence </label>
        <div>
          {{ seller.reference || "—" }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Nom Complet </label>
        <div>
          {{ seller.fullName || "—" }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Prénom </label>
        <div>
          {{ seller.firstName || "—" }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for=""> Nom </label>
        <div>
          {{ seller.lastName || "—" }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Téléphone</label>
        <div>
          {{ seller.phone || "—" }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">E-mail</label>
        <div>
          {{ seller.email || "—" }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Référence Employé</label>
        <div>
          {{ seller.employee_reference || "—" }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Utilisateur</label>
        <div>
          {{
            seller.user
              ? seller.user.name || seller.user.fullName || seller.user.email
              : "—"
          }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Créé le</label>
        <div>
          {{
            seller.created_at
              ? new Date(seller.created_at).toLocaleString("fr-FR")
              : "—"
          }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Modifié le</label>
        <div>
          {{
            seller.updated_at
              ? new Date(seller.updated_at).toLocaleString("fr-FR")
              : "—"
          }}
        </div>
      </div>

      <div class="col-xl-3 col-12 my-3">
        <label for="">Supprimé le</label>
        <div>
          {{
            seller.deleted_at
              ? new Date(seller.deleted_at).toLocaleString("fr-FR")
              : "—"
          }}
        </div>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-12">
        <h5 class="mb-3">
          Clients du Vendeur ({{
            seller.customers ? seller.customers.length : 0
          }})
        </h5>
        <vue-data-table
          v-if="seller.customers && seller.customers.length"
          :headers="customerHeaders"
          :data="seller.customers"
          :items-per-page="10"
        />
        <div v-else class="alert alert-info">
          Aucun client associé à ce vendeur.
        </div>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-12">
        <h5 class="mb-3">
          Ventes du Vendeur ({{ seller.sales ? seller.sales.length : 0 }})
        </h5>
        <vue-data-table
          v-if="seller.sales && seller.sales.length"
          :headers="saleHeaders"
          :data="seller.sales"
          :items-per-page="10"
        />
        <div v-else class="alert alert-info">
          Aucune vente associée à ce vendeur.
        </div>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-12">
        <h5 class="mb-3">
          Commandes du Vendeur ({{ seller.orders ? seller.orders.length : 0 }})
        </h5>
        <vue-data-table
          v-if="seller.orders && seller.orders.length"
          :headers="orderHeaders"
          :data="seller.orders"
          :items-per-page="10"
        />
        <div v-else class="alert alert-info">
          Aucune commande associée à ce vendeur.
        </div>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-12">
        <h5 class="mb-3">
          Paiements du Vendeur ({{
            seller.payments ? seller.payments.length : 0
          }})
        </h5>
        <vue-data-table
          v-if="seller.payments && seller.payments.length"
          :headers="paymentHeaders"
          :data="seller.payments"
          :items-per-page="10"
        />
        <div v-else class="alert alert-info">
          Aucun paiement associé à ce vendeur.
        </div>
      </div>
    </div>

    <br />
    <div class="row">
      <div class="col-12">
        <h5 class="mb-3">
          Articles Vendus ({{ seller.saleItems ? seller.saleItems.length : 0 }})
        </h5>
        <vue-data-table
          v-if="seller.saleItems && seller.saleItems.length"
          :headers="saleItemHeaders"
          :data="seller.saleItems"
          :items-per-page="10"
        />
        <div v-else class="alert alert-info">
          Aucun article vendu associé à ce vendeur.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      customerHeaders: [
        { label: "Référence", field: "reference", class: "text-left" },
        { label: "Nom Complet", field: "fullName", class: "text-left" },
        { label: "Prénom", field: "firstName", class: "text-left" },
        { label: "Nom", field: "lastName", class: "text-left" },
        { label: "Société", field: "society", class: "text-left" },
        { label: "Téléphone", field: "phone", class: "text-left" },
        { label: "E-mail", field: "email", class: "text-left" },
        { label: "CIN", field: "cin", class: "text-left" },
        { label: "ICE", field: "ice", class: "text-left" },
        { label: "IF", field: "if", class: "text-left" },
        { label: "Adresse", field: "address", class: "text-left" },
        { label: "Ville", field: "city", class: "text-left" },
        { label: "Code Postal", field: "zipCode", class: "text-left" },
        { label: "Max Impayé", field: "maxUnpaid", class: "text-right" },
        { label: "Latitude", field: "latitude", class: "text-right" },
        { label: "Longitude", field: "longitude", class: "text-right" },
        { label: "Remarque", field: "remark", class: "text-left" },
      ],
      saleHeaders: [
        { label: "Référence", field: "reference", class: "text-left" },
        {
          label: "Client Vendeur",
          field: "sellerCustomer.fullName",
          class: "text-left",
        },
        { label: "Date", field: "date", class: "text-left" },
        { label: "Échéance", field: "deadline", class: "text-left" },
        { label: "Total HT", field: "totalPriceHT", class: "text-right" },
        { label: "Total TTC", field: "totalPriceTTC", class: "text-right" },
        { label: "Total TVA", field: "totalPriceTVA", class: "text-right" },
        {
          label: "Quantité Totale",
          field: "totalQuantity",
          class: "text-right",
        },
        { label: "Montant Payé", field: "amountPaid", class: "text-right" },
        { label: "Montant Impayé", field: "amountUnpaid", class: "text-right" },
        { label: "Remarque", field: "remark", class: "text-left" },
      ],
      orderHeaders: [
        { label: "Référence", field: "reference", class: "text-left" },
        { label: "Date", field: "date", class: "text-left" },
        { label: "Échéance", field: "deadline", class: "text-left" },
        { label: "Total HT", field: "totalPriceHT", class: "text-right" },
        { label: "Total TTC", field: "totalPriceTTC", class: "text-right" },
        {
          label: "Quantité Totale",
          field: "totalQuantity",
          class: "text-right",
        },
        { label: "Montant Payé", field: "amountPaid", class: "text-right" },
        { label: "Montant Impayé", field: "amountUnpaid", class: "text-right" },
        { label: "Remarque", field: "remark", class: "text-left" },
      ],
      paymentHeaders: [
        { label: "Référence", field: "reference", class: "text-left" },
        {
          label: "Référence Vente Vendeur",
          field: "seller_sale_reference",
          class: "text-left",
        },
        {
          label: "Référence Paiement",
          field: "payment_reference",
          class: "text-left",
        },
        { label: "Date", field: "date", class: "text-left" },
        { label: "Montant", field: "amount", class: "text-right" },
        {
          label: "Montant Restant",
          field: "remainingAmount",
          class: "text-right",
        },
        { label: "Remarque", field: "remark", class: "text-left" },
      ],
      saleItemHeaders: [
        {
          label: "Référence Vente",
          field: "sale_reference",
          class: "text-left",
        },
        {
          label: "Référence Article",
          field: "item_reference",
          class: "text-left",
        },
        { label: "Nom Complet", field: "fullName", class: "text-left" },
        { label: "Prix TTC", field: "priceTTC", class: "text-right" },
        { label: "Quantité", field: "quantity", class: "text-right" },
        { label: "Total TTC", field: "totalPriceTTC", class: "text-right" },
      ],
    };
  },
  computed: {
    ...mapGetters("seller", {
      seller: "getSeller",
    }),
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("seller/show", this.$route.params.reference);
    },
  },
  beforeMount() {
    this.$store.dispatch("seller/show", this.$route.params.reference);
  },
};
</script>
